import { Icon } from '@snapchat/snap-design-system-marketing';
import type { FC } from 'react';

import { isUrl } from '../../../../../helpers/uri';
import {
  detailsCss,
  sourceItemCss,
  sourceLinkCss,
  sourcesListCss,
  sourceTitleCss,
  summaryCss,
  summaryIconCss,
} from './ExpandableSources.styles';

interface Source {
  title: string;
  url: string;
}

interface ExpandableSourcesProps {
  sources: Source[];
  onToggle?: () => void;
}

const getHostFromUrl = (url: string): string => {
  try {
    return new URL(url).hostname || url;
  } catch {
    return url;
  }
};

export const ExpandableSources: FC<ExpandableSourcesProps> = ({ sources, onToggle }) => {
  const cleanedSources = sources?.filter(source => isUrl(source?.url)) ?? [];

  if (!cleanedSources?.length) return null;

  return (
    <details className={detailsCss} onToggle={onToggle}>
      <summary className={summaryCss}>
        {cleanedSources.length === 1 ? '1 source' : `${cleanedSources.length} sources`}
        <Icon className={summaryIconCss} name="chevron-down" size={20} />
      </summary>
      <ul className={sourcesListCss}>
        {cleanedSources.map((source, index) => (
          <li key={index} className={sourceItemCss}>
            <span className={sourceTitleCss}>{source.title}</span>
            <a
              className={sourceLinkCss}
              href={source.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              {getHostFromUrl(source.url)}
            </a>
          </li>
        ))}
      </ul>
    </details>
  );
};

ExpandableSources.displayName = 'ExpandableSources';
